/**
 * TODO
 * Change this number to an environment variable so that both this variable and the
 * "$html-font-size" variable on the style are synced - instead of hardcoded in 2 places
 */
const htmlFontSize = 16;

export const remCalc = (value: number) => value / htmlFontSize;

export const breakpoints = {
  small: 320,
  medium: 768,
  large: 1024,
  xlarge: 1440,
  xxlarge: 1920,
};
